import Head from 'next/head'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { getBreadcrumbTrail } from '@/constants/breadcrumbs'

const BASE_URL = 'https://www.venturawebdesign.com'

const BreadcrumbsJsonLd = () => {
  const router = useRouter()

  const breadcrumbs = useMemo(() => {
    const cleanPath = router.asPath.split('?')[0].split('#')[0]
    const breadcrumbList = getBreadcrumbTrail(cleanPath).map(
      (breadcrumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.name,
        item: `${BASE_URL}${breadcrumb.href === '/' ? '/' : breadcrumb.href}`,
      }),
    )

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbList,
    }
  }, [router.asPath])

  return (
    <Head>
      <script
        key="breadcrumbs-json-ld"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbs) }}
      />
    </Head>
  )
}

export default BreadcrumbsJsonLd
